/* eslint-disable react-hooks/exhaustive-deps */
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { BoundStandardStepper } from "lib/@components/bound-standard-stepper"
import { BoundObjectEditor } from "lib/@components/bound-object-editor"
import { ChooseWorksheet } from "routes/asset-register/plugins/excel-import/choose-worksheet"
import { ChooseHeaderRow } from "routes/asset-register/plugins/excel-import/choose-header-row"
import { MapFields } from "routes/asset-register/plugins/excel-import/map-fields"
import { PreviewMapping } from "routes/asset-register/plugins/excel-import/preview-mapping"
import { Box } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { cleanObject } from "lib/clean-object"
import { useRefresh } from "lib/@hooks/useRefresh"
import { Finished } from "./finished"
import { ExcelImportFileChanged, ResetExcelImport } from "event-definitions"

export function ImportExcelSpreadsheet({ definition, ...props }) {
    return (
        <BoundObjectEditor target={definition}>
            <InnerImportExcelSpreadsheet {...props} />
        </BoundObjectEditor>
    )
}

function InnerImportExcelSpreadsheet() {
    const [step] = useBoundValue("step", 0)
    const { target } = useBoundContext()
    const refresh = useRefresh()
    ExcelImportFileChanged.useEvent(reset, [target])
    ResetExcelImport.useEvent(reset, [target])

    return (
        <Box pt={1} key={refresh.id}>
            <BoundStandardStepper activeStep={step} orientation="vertical" finishCaption="Import">
                <ChooseWorksheet
                    label="Select Excel Tab/Sheet"
                    optional="Data can only be selected from one tab/sheet in the file, please select which tab to use."
                    blockBack={true}
                />
                <ChooseHeaderRow
                    label="Select Header Row"
                    optional="Define which row in your dataset is the header for your data fields."
                />
                <MapFields
                    label="Select Fields"
                    optional="Identify which fields in your dataset match fields in Facilities-iQ."
                />
                <PreviewMapping
                    label="Review & Filter"
                    continueCaption="Import"
                    optional="Review data structure before importing"
                />
                <Finished label="Import" optional="Load your data into Facilities-iQ." blockBack={true} />
            </BoundStandardStepper>
        </Box>
    )

    function reset() {
        cleanObject(target)
        refresh()
    }
}
